<template>
    <div :key="key" :class="[`range-custom`,classCustom]">
        <el-input class="min-input"
                  v-model.trim="value.min"
        />
        <span style="padding: 0 7px">-</span>
        <el-input
                class="max-input"
                v-model.trim="value.max"
        />
    </div>
</template>

<script>
    export default {
        name: "InputrangeCustom",

        props: {
            value: {
                default: () => ({
                    min: "",
                    max: "",
                }),
                type: Object
            },

            classCustom: {
                type: String,
                default: ""
            }

        },

        data() {
            return {
                key: `InputCustomID-${Math.random()
                    .toString(36)
                    .slice(2)}`
            };
        },

        watch: {
            value: {
                deep: true,
                handler(val) {
                    this.$emit("input", val);
                    this.$emit("change", val);
                }
            }
        }
    };
</script>

<style lang="scss">
    .range-custom {
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .min-input, .max-input {
            width: 80px;
        }
    }
</style>
